import Reveal from "@/components/base/Reveal";
import Eyebrow from "@/components/base/Eyebrow";
import Tag from "@/components/base/Tag";
import { brokerPartners, partnerDisclosure } from "@/mocks/brokers";

export default function BrokerPartners() {
  return (
    <section
      id="brokers"
      className="px-4 md:px-8 py-16 md:py-24 bg-background-200 border-y-2 border-foreground-950 scroll-mt-[68px]"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6">
          <div className="max-w-3xl">
            <Eyebrow>Partner brokers</Eyebrow>
            <h2 className="mt-4 font-heading font-black uppercase leading-[0.92] tracking-tight text-foreground-950 text-3xl md:text-5xl">
              Where to place these orders
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-600 lg:pb-2">
            Order types are standard everywhere — platforms and pricing are not. Three brokers we
            point readers to when they are ready to trade a live account.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {brokerPartners.map((broker, index) => (
            <Reveal key={broker.name} delay={index * 90} className="h-full">
              <article className="h-full flex flex-col border-2 border-foreground-950 bg-background-50 p-5 md:p-6 transition-colors hover:border-primary-600">
                <div className="flex items-start justify-between gap-3">
                  <span
                    aria-hidden="true"
                    className="font-label text-[11px] uppercase tracking-[0.2em] text-foreground-500 pt-1"
                  >
                    0{index + 1}
                  </span>
                  <Tag tone={index === 0 ? "primary" : index === 1 ? "accent" : "secondary"}>
                    {broker.badge}
                  </Tag>
                </div>

                <div className="mt-5 flex items-center gap-3">
                  <img
                    src={broker.logo}
                    alt={`${broker.name} logo`}
                    width={44}
                    height={44}
                    className="w-11 h-11 shrink-0 border-2 border-foreground-950 object-cover"
                  />
                  <h3 className="font-heading font-black uppercase tracking-tight leading-none text-2xl text-foreground-950">
                    {broker.name}
                  </h3>
                </div>

                <p className="mt-4 text-sm leading-relaxed text-foreground-800 font-semibold">
                  {broker.tagline}
                </p>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{broker.note}</p>

                <dl className="mt-5 border-t-2 border-foreground-950/15">
                  {broker.specs.map((spec) => (
                    <div
                      key={spec.label}
                      className="flex items-start justify-between gap-3 py-2.5 border-b-2 border-foreground-950/10"
                    >
                      <dt className="font-label text-[10px] uppercase tracking-[0.14em] text-foreground-500 pt-0.5">
                        {spec.label}
                      </dt>
                      <dd className="text-xs text-foreground-800 text-right leading-relaxed">
                        {spec.value}
                      </dd>
                    </div>
                  ))}
                </dl>

                <div className="mt-auto pt-6">
                  <a
                    href={broker.url}
                    target="_blank"
                    rel="sponsored nofollow noopener noreferrer"
                    aria-label={`Visit ${broker.name} (partner link, opens in a new tab)`}
                    className="flex items-center justify-between gap-2 px-4 py-3 border-2 border-foreground-950 bg-foreground-950 text-primary-500 font-label text-[11px] uppercase tracking-[0.14em] font-semibold whitespace-nowrap transition-colors hover:bg-primary-500 hover:text-foreground-950 cursor-pointer"
                  >
                    Visit {broker.name}
                    <i className="ri-arrow-right-up-line text-base"></i>
                  </a>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <div className="mt-6 border-l-2 border-accent-500 bg-background-50 px-5 py-4">
          <p className="font-label text-[11px] leading-relaxed text-foreground-600">
            {partnerDisclosure}
          </p>
        </div>
      </div>
    </section>
  );
}